import { useQuery } from "@tanstack/react-query";
import {
  CurrentCompanySettingsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENT_COMPANY_SETTINGS = "GET_CURRENT_COMPANY_SETTINGS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCurrentCompanySettings = async (): Promise<CurrentCompanySettingsDto> => {
  const response = await companiesApi.companiesControllerGetCurrentCompanySettings();

  return response.data;
};

export const useGetCurrentCompanySettings = (
  user: UserProfileDto | null,
): {
  currentCompanySettings?: CurrentCompanySettingsDto;
  currentCompanySettingsEnabled: boolean;
  isPendingGetCurrentCompanySettings: boolean;
  isFetchingCurrentCompanySettings: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending, isFetching } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_SETTINGS],
    queryFn: () => getCurrentCompanySettings(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    currentCompanySettings: data,
    currentCompanySettingsEnabled: enabled,
    isPendingGetCurrentCompanySettings: isPending,
    isFetchingCurrentCompanySettings: isFetching,
  };
};
